<template>
  <router-view />
  <FullLoading v-if="loading" />
</template>
<script>
import FullLoading from "@/components/FullLoading";
import { useStore } from "vuex";
import { onMounted, computed, watch } from "vue";
import { accessGames, coreUser } from "@/api";
export default {
  components: {
    FullLoading
  },
  setup() {
    const store = useStore();
    let loading = computed(() => store.state.settings.loading);
    let tokenRef = computed(() => store.state.settings.token);
    onMounted(() => {
      if (tokenRef) {
        accessGames().then(res => {
          if (res.status === 200) {
            console.log(res, "accesGames");
            let data = res.data.accessGames;
            let codeList = [];
            codeList = data.map(item => item.code);
            console.log(codeList, "codeList");
            store.commit("settings/gameCodeListChange", codeList);
            store.commit("settings/asscessGamesListChange", data);
          }
        });
        // userInfo
        coreUser()
          .then(res => {
            if (res.status === 200) {
              store.commit("settings/rolesChange", res.data.roles);
              store.commit("settings/userInfoChange", res.data.userInfo);
            }
          })
          .catch(error => {
            if (error.response) {
              let res = error.response;
              if (res.data.exception.error_code === 400800) {
                window.location.href = "/auth/login";
              }
            }
          });
      }
    });
    return {
      loading
    };
  }
};
</script>
<style lang="less">
.ant-spin-nested-loading > div > .ant-spin {
  max-height: 100% !important;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
